import Youtube from "./Youtube.jsx";

function App() {
  return (
    <>
      <h1>Classic React App</h1>
      <Youtube />
    </>
  );
}

export default App;